import { ReactNode, useCallback, useState } from 'react';
import { Company } from 'src/types';
import { AddContactContext, AddContactContextInitialData, InitialInsured } from './context';

export const AddContactProvider = ({ children }: { children: ReactNode }) => {
  const [isAddContactOpen, setIsAddContactOpen] = useState(false);
  const [initialInsured, setInitialInsured] = useState<InitialInsured>();
  const [initialCompany, setInitialCompany] = useState<Company>();
  const [currentPageCompany, setCurrentPageCompany] = useState<Company>();

  const openAddContact = useCallback((initialData?: AddContactContextInitialData) => {
    setInitialInsured(initialData?.insured);
    setInitialCompany(initialData?.company);
    setIsAddContactOpen(true);
  }, []);

  const closeAddContact = useCallback(() => {
    setInitialInsured(undefined);
    setInitialCompany(undefined);
    setIsAddContactOpen(false);
  }, []);

  return (
    <AddContactContext.Provider
      value={{
        isAddContactOpen,
        initialInsured,
        initialCompany,
        currentPageCompany,
        openAddContact,
        closeAddContact,
        setCurrentPageCompany,
      }}
    >
      {children}
    </AddContactContext.Provider>
  );
};
